import {useEffect} from "react";
import * as shopService from "../service/shopService";
import {getShopAdminInfoApi, getShopInfoApi} from "../service/shopService";
import {getOrderShopInfoApi} from "../../../api/shopApi";
import {getOrderCostApi, getOrderWeatherCostApi} from "../../../api/costApi";

export function useShopInfo(setters, shopId) {
  useEffect(() => {
    const shopInfo = async () => {
      if(shopId) {
        const shopData = await shopService.getShopInfo(shopId);
        let deliType = 1;
        if (shopData.distanceExtraList?.length > 0) deliType = 2;


        setters.setPayTypeList?.(shopData.paymentTypeList);
        setters.setDongList?.(shopData.deliverableAreaList);
        setters.setServiceType?.(shopData.serviceType);
        setters.setDeliType?.(deliType);
      }
    }
    shopInfo();
  }, [shopId])
}

export function useShopAdminDetail2(setters, shopId) {
  useEffect(() => {
    const shopInfo = async () => {
      if(shopId) {
        const shopData = await shopService.getAdminShopInfo(shopId);

        setters.setLoginId?.(shopData[0].loginId);
        setters.setName?.(shopData[0].reptName);
        setters.setTel?.(shopData[0].reptTel);
        setters.setEmail?.(shopData[0].shopEmail);
        setters.setApprovalTpcd1?.(shopData[0].approvalTpcd1);
      }
    }
    shopInfo();
  }, [shopId])
}

export function useShopAdminDetail(setters, shopId) {
  useEffect(() => {
    const shopInfo = async () => {
      if(shopId) {
        const shopData = await shopService.getShopAdminDetail(shopId);

        setters.setRealName?.(shopData.realName);
        setters.setBirth?.(shopData.birth);
        setters.setEmail?.(shopData.email);
        setters.setRoad?.(shopData.road);
        setters.setJibun?.(shopData.jibun);
        setters.setAddressDetail?.(shopData.addressDetail);
        setters.setLat?.(shopData.lat);
        setters.setLng?.(shopData.lng);
        setters.setBizType?.(shopData.bizType);
        setters.setBizNo?.(shopData.bizNo);
        setters.setReptName?.(shopData.reptName);
        setters.setBizCond?.(shopData.bizCond);
        setters.setBizItem?.(shopData.bizItem);
        setters.setBank?.(shopData.bank);
        setters.setBankAccountHolder?.(shopData.bankAccountHolder);
        setters.setBankAccount?.(shopData.bankAccount);
      }
    }
    shopInfo();
  }, [shopId])
}


// shopInfo1 데이터 조회
export function useAdminShopInfo(setters, shopId) {
  useEffect(() => {
    const shopInfo = async () => {
      if(shopId) {
        const shopData = await shopService.getAdminShopInfo(shopId);
        const logoData = await shopService.getImageList(shopId, 6);
        const noticeData = await shopService.getImageList(shopId, 7);
        const categoryData = await shopService.getCategory(shopId);

        setters.setShopName?.(shopData[0].shopName);
        setters.setShopStatus?.(shopData[0].statusTpcd);
        setters.setServiceType?.(shopData[0].serviceTpcd);
        setters.setAddress?.(shopData[0].addrRoad);
        setters.setShopTel?.(shopData[0].shopTel);
        setters.setDeliveryType?.(shopData[0].deliAppTp);
        setters.setDeliveryDoneMinutes?.(shopData[0].deliCmplTm);
        setters.setBundleDoneMinutes?.(shopData[0].wrapCmplTm);
        setters.setIntro?.(shopData[0].shopInfo);
        setters.setNotice?.(shopData[0].shopNotice);
        setters.setLogoImage?.(logoData);
        setters.setNoticeImage?.(noticeData);
        setters.setCategory?.(categoryData);
        setters.setApprovalTpcd1?.(shopData[0].approvalTpcd1);
        setters.setApprovalTpcd2?.(shopData[0].approvalTpcd2);
        setters.setCorpNo?.(shopData[0].crNum);
        setters.setTel?.(shopData[0].shopTel);
        setters.setReptTel?.(shopData[0].reptTel);
      }
    }
    shopInfo();
  }, [shopId]);
}

// shopInfo1 페이지 데이터 조회
export function useGetShopInfo1(setters, shopId) {
  useEffect(() => {
    const response = async () => {
      if(shopId) {
        const shopData = await getShopInfoApi(shopId);
        const shopAdminData = await getShopAdminInfoApi(shopId);
        const logoData = await shopService.getImageList(shopId, 6);
        const noticeData = await shopService.getImageList(shopId, 7);

        setters.setShopName?.(shopData.name);
        setters.setShopStatus?.(shopAdminData.status);
        setters.setServiceType?.(shopData.serviceType);
        setters.setAddress?.(shopData.road);
        setters.setShopTel?.(shopData.tel);
        setters.setDeliveryType?.(shopData.deliveryTypeList);
        setters.setDeliveryDoneMinutes?.(shopData.deliveryDoneMinutes);
        setters.setBundleDoneMinutes?.(shopData.packagingDoneMinutes);
        setters.setIntro?.(shopData.intro);
        setters.setNotice?.(shopData.notice);
        setters.setNoticeImage?.(noticeData);
        setters.setLogoImage?.(logoData);
        setters.setCategory?.(shopData.categoryNameList);
        setters.setPayTypeList?.(shopData.paymentTypeList);
        setters.setApprovalTpcd1?.(shopAdminData.approvalType1);
        setters.setFeeType?.(shopData.feeType || 0);
        setters.setRoad?.(shopData.road);
        setters.setLat?.(shopData.lat);
        setters.setLng?.(shopData.lng);
        setters.setJibun?.(shopData.jibun);
        setters.setAddressDetail?.(shopData.addressDetail);
        setters.setDeliverySettingType?.(shopData.deliveryCostCalculateType || 1);
      }
    }
    response();
  }, [shopId]);
}

// shopInfo2 데이터 조회
export function useShopInfo2(setters, shopId) {
  useEffect(() => {
    const shopData = async () => {
      if(shopId) {
        const imageData = await shopService.getImageList(shopId, 8)

        setters.setImageList?.(imageData);
      }
    }
    shopData();
  }, [shopId]);
}

// shopInfo3 데이터 조회
export function useShopInfo3(setters, shopId) {
  useEffect(() => {
    const shopData = async () => {
      if(shopId) {
        const timeData = await shopService.getShopTime(shopId);
        let timeData1 = [];
        let timeData2 = [];

        const orderShopInfoData = await getOrderShopInfoApi(shopId);
        let startTimeList = [];
        let endTimeList = [];

        orderShopInfoData.operationTimeList.sort(function(a, b) {
          return parseFloat(a.dayOfWeek) - parseFloat(b.dayOfWeek);
        });

        orderShopInfoData.operationTimeList.forEach((value) => {
          if (value.type === 1) {
            startTimeList.push(value);
          } else {
            endTimeList.push(value);
          }
        })


        if(timeData.length > 0) {
          timeData.sort(function(a, b) {
            return parseFloat(a.dayOfWeekType) - parseFloat(b.dayOfWeekType);
          });

          for(let i = 0; timeData.length > i; i++) {
            if(timeData[i].operTp === 1) {
              timeData1.push(timeData[i])
            } else {
              timeData2.push(timeData[i])
            }
          }
        }

        console.log(timeData);

        if (timeData1.length > 0) timeData1.sort((a, b) => a.dowTpcd - b.dowTpcd);
        if (timeData2.length > 0) timeData2.sort((a, b) => a.dowTpcd - b.dowTpcd);

        const holidayData = await shopService.getHolidayList();
        const shopHolidayData = await shopService.getShopHoliday(shopId);
        const shopLegalHolidayData = await shopService.getShopLegalHoliday(shopId);
        const shopInfoData = await shopService.getAdminShopInfo(shopId);

        setters.setShopTime1?.(timeData1);
        setters.setShopTime2?.(timeData2);
        setters.setHolidayList?.(holidayData);
        setters.setShopHolidayList?.(shopHolidayData);
        setters.setShopLegalHolidayList?.(shopLegalHolidayData);
        setters.setStartDate?.(shopInfoData[0].tempStartDt);
        setters.setEndDate?.(shopInfoData[0].tempEndDt);
        setters.setStatus?.(shopInfoData[0].statusTpcd);
        setters.setPauseStartDate?.(shopInfoData[0].pauseStartTs);
        setters.setPauseEndDate?.(shopInfoData[0].pauseEndTs);
        setters.setApprovalTpcd1?.(shopInfoData[0].approvalTpcd1);
        setters.setStartTimeList?.(startTimeList);
        setters.setEndTimeList?.(endTimeList);
        setters.setTempClosingStartDate?.(orderShopInfoData.tempClosingStartDate);
        setters.setTempClosingEndDate?.(orderShopInfoData.tempClosingEndDate);
      }
    }
    shopData();
  }, [shopId]);
}

// shopInfo4 데이터 조회
export function useShopInfo4(setters, shopId) {
  useEffect(() => {
    const shopData = async () => {
      if(shopId) {
        const shopData = await shopService.getAdminShopInfo(shopId);
        const dongCostData = await shopService.getDongCost(shopId);
        const timeCostData = await shopService.getTimeCost(shopId);
        const distanceData = await shopService.getDistanceApi(shopId);
        let freeCostData = await shopService.getFreeCostApi(shopId);
        const weatherData = await getOrderWeatherCostApi(shopId);
        const ceoShopData = await getShopInfoApi(shopId);
        const costData = await getOrderCostApi(shopId);

        freeCostData = freeCostData.sort(function(a, b) {
          return parseFloat(a.distance) - parseFloat(b.distance);
        });

        let dongCostData2;
        let dongCostList = [];
        let dongValueList = [];
        let dongCostOutput = [];
        const dongList = await shopService.getShopInfoApi(shopId);

        if(dongCostData.length > 0) {
          dongCostData2 = dongCostData.sort(function(a, b) {
            return parseFloat(a.extraCost) - parseFloat(b.extraCost);
          });

          for(let i = 0; dongCostData2.length > i; i++) {
            if(i === 0) {
              dongValueList.push(dongCostData2[i].extraCost)
            } else {
              if(dongCostData2[i].extraCost !== dongCostData2[i - 1].extraCost) {
                dongValueList.push(dongCostData2[i].extraCost)
              }
            }
          }

          dongCostList = dongCostData2.reduce(function(a, b) {
            if(!a[b.extraCost]) {
              a[b.extraCost] = [b];
            } else {
              a[b.extraCost] = a[b.extraCost].concat(b);
            }
            return a;
          }, {});

          for(let i = 0; dongValueList.length > i; i++) {
            dongCostOutput.push(dongCostList[dongValueList[i]])
          }
        }

        let getDeliveryCostData = dongList.deliveryCostData;

        setters.setMinOrderCost?.(dongList.minOrderCost);
        setters.setPackagingCost?.(dongList.packagingDiscountCost);
        setters.setDongExtraList?.(dongCostData2 === undefined ? [] : dongCostData2);
        setters.setDongList?.(dongList.deliverableAreaList);
        setters.setOutput?.(dongCostOutput)
        setters.setTimeExtraList?.(timeCostData);
        setters.setApprovalTpcd1?.(shopData[0].approvalTpcd1);
        setters.setDefaultDist?.(getDeliveryCostData.basicDistance);
        setters.setDefaultDistCost?.(getDeliveryCostData.basicDeliveryCost);
        setters.setAddDistId?.(distanceData[0] ? distanceData[0].id : 0);
        setters.setAddDist?.(distanceData[0] ? distanceData[0].testDistance : 0.1);
        setters.setAddDistCost?.(distanceData[0] ? distanceData[0].cost : 0);
        setters.setDistanceExtraList?.(dongList.distanceExtraList);
        setters.setFreeCostList?.(freeCostData);
        setters.setWeatherCost?.(weatherData || {cost: 0, enabled: false});
        setters.setDeliverySettingType?.(ceoShopData.deliveryCostCalculateType || 1);
        setters.setCostList?.(costData);
      }
    }
    shopData();
  }, [shopId]);
}

export function useCategory(setters, serviceType) {
  useEffect(() => {
    const response = async () => {
      if(serviceType) {
        const data = await shopService.getAllCategory(serviceType);
        setters.setCategoryList?.(data);
      }
    }
    response();
  }, [serviceType]);
}

export function useShopCategory(setters, shopId) {
  useEffect(() => {
    const response = async () => {
      if(shopId) {
        const data = await shopService.getCategory(shopId);
        setters.setCategory?.(data);
      }
    }
    response();
  }, [shopId]);
}

export function useShopOrigin(setters, shopId) {
  useEffect(() => {
    const response = async () => {
      if(shopId) {
        const data = await shopService.getShopOrigin(shopId);
        setters.setOrigin?.(data);
      }
    }
    response();
  }, [shopId]);
}

export function useGetStoreListApi(setters, userId, userType) {
  useEffect(() => {
    const response = async () => {
      if(userId && userType) {
        const data = await shopService.getStoreListApi(userId, userType);
        setters.setShopList?.(data);
      }
    }
    response();
  }, [userId, userType]);
}

// 상점 이미지
export function useGetShopImageApi(setters, shopId, type) {
  useEffect(() => {
    const shopData = async () => {
      if(shopId) {
        const imageData = await shopService.getImageList(shopId, type)

        setters.setImageList?.(imageData);
      }
    }
    shopData();
  }, [shopId, type]);
}

// 하위 상점 조회
export function useShopLowerApi(setters, shopId) {
  useEffect(() => {
    const response = async () => {
      if(shopId) {
        const shopData = await shopService.getShopLowerApi(shopId);

        setters.setShopList?.(shopData);
      }
    }
    response();
  }, [shopId]);
}